import React from 'react'
import { connect } from 'react-redux'

import { fetchUserInfo } from 'actions'
import { makeRoomUserIdsSelector, userInfosSelector } from 'selectors'

import Room from './Room'

class RoomWrapper extends React.Component {
  componentDidMount() {
    this.props.roomUserIds.forEach(userId => {
      if (!this.props.userInfos.includes(userId)) {
        this.props.fetchUserInfo(userId)
      }
    })
  }

  render() {
    return <Room {...this.props} />
  }
}

const makeMapStateToProps = () => {
  const roomUserIdsSelector = makeRoomUserIdsSelector()
  return (state, props) => ({
    userInfos: userInfosSelector(state) || [],
    roomUserIds: roomUserIdsSelector(state, props) || [],
  })
}

const mapDispatchToProps = { fetchUserInfo }

export default connect(makeMapStateToProps, mapDispatchToProps)(RoomWrapper)



// WEBPACK FOOTER //
// ./src/components/chat/RoomWrapper.js